import {sum}    from "../../utils/collections";
import {chain}  from "../../utils/fs";
import {values} from "../../utils/objects";

import {itemCreditLines} from "./item-credit-lines";

export const getCartPurchaseLines = (cart) => {
    const total = combineItemTotals(cart.items.map((i) => values(i.itemTotals)));

    return [
        {
            label: "Order(s) Subtotal",
            value: (
                total.find((t) => t.type === "subTotal").amount
            ),
            big: true,
        },
        chain(
            total.find((t) => t.type === "shippingCharge"),
            (t) => t && ({
                label: "Shipping Total",
                value: t.amount,
            }),
        ),
        chain(
            total.find((t) => t.type === "handlingFee"),
            (t) => t && ({
                label: "Handling Fee Total",
                value: t.amount,
            })
        ),
        chain(
            total.find((t) => t.type === "salesTax"),
            (t) => t && ({
                label: "Sales Tax Total",
                value: t.amount,
            }),
        ),
        chain(
            total.find((t) => t.type === "rdf"),
            (t) => t && ({
                label: t.name + " Total",
                value: t.amount,
                description: t.description,
            }),
        ),
        chain(
            total.find((t) => t.type === "vatTax"),
            (t) => t && ({
                label: "VAT/GST Total",
                value: t.amount,
                description: t.description,
            }),
        ),
        chain(
            total.find((t) => t.type === "importTax"),
            (t) => t && ({
                label: "Import Duties Total",
                value: t.amount,
            }),
        ),
        chain(
            sum(cart.items, (item) => sum(itemCreditLines({item, cart}), (line) => line.value)),
            (t) => t && ({
                label: "Credit Totals",
                value: t,
            })
        ),
    ].filter(v => v);
};



const combineItemTotals = (allItemTotals) => {
    let ret = allItemTotals[0];
    for (let i = 1; i < allItemTotals.length; i++) {
        const itemTotals = allItemTotals[i];
        ret = combine(ret, itemTotals);
    }
    return ret;
};


const combine = (t1,t2) => {
    let ret = [...t1];
    for (const t of t2) {
        const e1 = ret.find((e) => e.type === t.type);
        if (e1) {
            ret = ret.map((e2) => e2 === e1 ? {
                ...e2,
                amount: e2.amount + t.amount,
            } : e2);
        } else {
            ret = [...ret, t];
        }
    }
    return ret;
};

